"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalSelectors = void 0;
const reselect_1 = require("reselect");
const selectGlobalState = (state) => state.global;
const selectSUMO1UserState = (state) => state.SUMO1_user;
const selectSUMOCEPUserState = (state) => state.SUMOCEP_user;
const selectServerUrl = (0, reselect_1.createSelector)(selectGlobalState, (global) => global.serverUrl);
const selectServerType = (0, reselect_1.createSelector)(selectGlobalState, (global) => global.serverType);
const selectServerEnvironment = (0, reselect_1.createSelector)(selectGlobalState, (global) => global.serverEnvironment);
const selectServerPrefix = (0, reselect_1.createSelector)(selectGlobalState, (global) => global.serverPrefix);
const selectExtensionIntegration = (0, reselect_1.createSelector)(selectGlobalState, (global) => global.extensionIntegration);
const selectIsFetchingUserData = (0, reselect_1.createSelector)(selectGlobalState, (global) => global.isFetchingUserData);
const selectIsAuthorized = (0, reselect_1.createSelector)(selectGlobalState, (global) => global.isAuthorized);
const selectIsFetching = (0, reselect_1.createSelector)(selectGlobalState, (global) => global.isFetching);
const selectDefaultHost = (0, reselect_1.createSelector)(selectGlobalState, (global) => global.defaultHost);
const selectUser = (0, reselect_1.createSelector)(selectServerType, selectSUMO1UserState, selectSUMOCEPUserState, (serverType, SUMO1UserState, SUMOCEPUserState) => {
    return serverType === "SUMO" /* ServerType.SUMO */ ? SUMO1UserState.user : SUMOCEPUserState.user;
});
const selectRole = (0, reselect_1.createSelector)(selectServerType, selectSUMO1UserState, selectSUMOCEPUserState, (serverType, SUMO1UserState, SUMOCEPUserState) => {
    return serverType === "SUMO" /* ServerType.SUMO */ ? SUMO1UserState.role : SUMOCEPUserState.role;
});
exports.globalSelectors = {
    selectServerUrl,
    selectServerType,
    selectServerEnvironment,
    selectServerPrefix,
    selectDefaultHost,
    selectExtensionIntegration,
    selectIsFetchingUserData,
    selectIsAuthorized,
    selectIsFetching,
    selectUser,
    selectRole,
};
